<mwe-tariff-card-template
  [category]="product().category"
  [hasActions]="hasActions()"
  [hasContent]="hasContent()"
  [hasDiscount]="hasDiscount()"
  [headlineReference]="headlineReference()"
  [isSpot]="isSpot()"
  [spotUrl]="spotUrl()"
  [state]="state()"
  [subTitle]="isWaerme() ? '' : (product().category | translateCategory)"
  [title]="isWaerme() ? (product().category | translateCategory) : (product() | translateTariffClass | async)"
  [product]="product()"
>
  <ng-content />
  <ng-content select="[slot='actions']" slot="actions" />
</mwe-tariff-card-template>
